export class ServerPaginationParameters {
    batch: number;
    count: number;
    filter: string;
    sortBy: string;
    sortDirection: string;
}
  